import Api from "../axios";

export const getPersonalInfo = async (currentEmployeeId) => {
  return await Api.get(`/profile?employeeId=${currentEmployeeId}`);
};
